import { ERP } from '../_base/endpoint';
import axios from 'axios';

class accesoService{
    async obtenerPorIdRol(id) {
        const response = await axios
            .get(`${ERP}seguridad/acceso/treeview-acceso-por-rol/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}seguridad/acceso`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new accesoService();